import React, { FC } from "react";

import { ApiCallStatus } from "../../../api-http/types";
import { Button } from "../../buttons/button";
import { Modal } from "../../modal";
import { Spinner } from "../../spinner";

export interface ResponseModalProps {
  responseStatus: ApiCallStatus;
  labels: ResponseModalLabels;
  isOpen: boolean;
}

export type ResponseModalLabels = Record<
  | "forms-personal-area-success-title"
  | "forms-personal-area-success-abstract"
  | "forms-personal-area-failed-title"
  | "forms-personal-area-failed-abstract"
  | "forms-personal-area-close-modal"
  | "forms-personal-area-sending-request",
  string
>;

export const ResponseModal: FC<ResponseModalProps> = ({ responseStatus, labels, isOpen }) => {
  return (
    <Modal isOpen={isOpen} onClose={() => window?.location?.reload()}>
      {responseStatus === ApiCallStatus.LOADING ? (
        <div className="flex flex-col gap-5 p-5 items-center">
          <div className="text-lg text-dark font-light">
            {labels["forms-personal-area-sending-request"]}
          </div>
          <Spinner className="mx-auto" size="large" />
        </div>
      ) : (
        <div className="flex flex-col gap-5 p-5 items-center">
          <div className="text-3xl text-primary font-medium">
            {responseStatus === ApiCallStatus.SUCCESS
              ? labels["forms-personal-area-success-title"]
              : labels["forms-personal-area-failed-title"]}
          </div>
          <div className="text-lg text-dark font-light">
            {responseStatus === ApiCallStatus.SUCCESS
              ? labels["forms-personal-area-success-abstract"]
              : labels["forms-personal-area-failed-abstract"]}
          </div>
          <Button variant="primary" onClick={() => window?.location?.reload()}>
            {labels["forms-personal-area-close-modal"]}
          </Button>
        </div>
      )}
    </Modal>
  );
};
